import { Avatar, Button, Dropdown } from "antd";
import ProLayout from "@ant-design/pro-layout";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { defaultSettings } from "css/defaultAntStyles";
import {
  HomeOutlined,
  PlusOutlined,
  ProjectOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MyLogo } from "Components/MyLogo/MyLogo";
import { useDispatch, useSelector } from "react-redux";
import {
  logoutUserThunk,
  selectUser,
} from "AppStore/Slices/UserSlice/UserSlice";
import { checkRoleAccess } from "Helpers/checkRoleAccess";
import { setResetProjectData } from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { ROLE } from "Helpers/roles/roles";
const userMenu = [{ key: "logout", label: "Вийти" }];

const routesConfig = [
  {
    path: "/",
    name: "Початок роботи",
    icon: <HomeOutlined />,
  },
  {
    path: "/admin",
    name: "Адмін",
    icon: <TeamOutlined />,
    roles: [ROLE.ADMIN],
    routes: [
      {
        path: "/admin/users",
        name: "Користувачі",
        roles: [ROLE.ADMIN],
      },
      {
        path: "/admin/jobs",
        name: "Роботи",
        roles: [ROLE.ADMIN],
      },
    ],
  },
  {
    path: "/projects",
    name: "Проекти",
    icon: <ProjectOutlined />,
    // roles: [ROLE.ADMIN, ROLE.MANAGER, ROLE.ENGINEER],
    routes: [
      {
        path: "/projects/my",
        name: "Мої проекти",
        roles: [ROLE.ADMIN, ROLE.ENGINEER, ROLE.MANAGER, ROLE.WORKER],
      },
      {
        path: "/projects/all",
        name: "Всі проекти",
        roles: [ROLE.ADMIN],
      },
    ],
  },
];

const filterRoutesByRole = (routes, userRoleArray) => {
  return routes
    .filter((route) => {
      if (!route.roles) return true;
      return route.roles.some((roleForThisRoute) => {
        return userRoleArray.includes(roleForThisRoute);
      });
    })
    .map((route) => ({
      ...route,
      routes: route.routes
        ? filterRoutesByRole(route.routes, userRoleArray)
        : undefined,
    }));
};

export default function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { roles, user } = useSelector(selectUser);

  const filteredRoutes = filterRoutesByRole(routesConfig, roles);
  return (
    <ProLayout
      layout={defaultSettings.layout}
      fixedHeader={defaultSettings.fixedHeader}
      fixSiderbar={defaultSettings.fixSiderbar}
      splitMenus={defaultSettings.splitMenus}
      navTheme={defaultSettings.navTheme}
      logo={false}
      headerTitleRender={() => <MyLogo fontSize={16} marginRight={34} />}
      location={{ pathname: location.pathname }}
      menuItemRender={(item, dom) => (
        <div onClick={() => navigate(item.path)}>{dom}</div>
      )}
      route={{
        path: "/",
        routes: filteredRoutes,
      }}
      actionsRender={() => [
        checkRoleAccess([ROLE.ADMIN, ROLE.ENGINEER], roles) && (
          <Button
            key="create"
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              dispatch(setResetProjectData());
              navigate("/projects/create");
            }}
          >
            Створити проект
          </Button>
        ),

        <Dropdown
          key="user"
          menu={{
            items: userMenu,
            onClick: ({ key }) => {
              if (key === "logout") {
                dispatch(logoutUserThunk());
                navigate("/user/login");
                return;
              }
              navigate(`/user/${key}`);
            },
          }}
          trigger={["click"]}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
              padding: "0 10px",
            }}
          >
            <Avatar
              icon={<UserOutlined />}
              src={"/img/palogo.jpg"}
              shape="square"
            />
            <span>{user.name}</span>
          </div>
        </Dropdown>,
      ]}
    >
      <Outlet />
    </ProLayout>
  );
}
